import { SistemaInfo } from './sistema-info';
export class Sistema {
  idSistema: number = null;
  dsNomeSist: string = null;
  dsSiglaSist: string = null;
  versaoMinima: Date = null;
  versaoAtual: string = null;
  sistemaInfo: SistemaInfo = null;

  constructor(d?) {
    if (d) {
      this.idSistema = d.idSistema ? d.idSistema : null;
      this.dsNomeSist = d.dsNomeSist ? d.dsNomeSist : null;
      this.dsSiglaSist = d.dsSiglaSist ? d.dsSiglaSist : null;
      this.versaoMinima = d.versaoMinima ? d.versaoMinima : null;
      this.versaoAtual = d.versaoAtual ? d.versaoAtual : null;
      this.sistemaInfo = d.sistemaInfo ? new SistemaInfo(d.sistemaInfo) : null;
    }
  }
}
